export default __webpack_public_path__ + "assets/slide-1.77c98ca2.png";